import { render, staticRenderFns } from "./BackgroundImage.vue?vue&type=template&id=154e532c&scoped=true&lang=pug&"
import script from "./BackgroundImage.vue?vue&type=script&lang=js&"
export * from "./BackgroundImage.vue?vue&type=script&lang=js&"
import style0 from "./BackgroundImage.vue?vue&type=style&index=0&id=154e532c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154e532c",
  null
  
)

export default component.exports